import { Tabs, Tab } from "react-bootstrap";
import EmailTab from "./components/EmailTab";
import SMSTab from "./components/SMSTab";
import WhatsAppTab from "./components/WhatsAppTab";

export default function App() {
  return (
    <div className="container mt-5">
      <div className="dashboard-card">
        <h3 className="text-center">Notification Dashboard</h3>

        <Tabs defaultActiveKey="email" className="mt-3">
          <Tab eventKey="email" title="📧 Email">
            <EmailTab />
          </Tab>
          <Tab eventKey="sms" title="📱 SMS">
            <SMSTab />
          </Tab>
          <Tab eventKey="whatsapp" title="💬 WhatsApp">
            <WhatsAppTab />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}
